import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
   const [year, setYear] = useState(null);
   const API_URL = process.env.REACT_APP_API_URL;


   useEffect(() => {
    fetchData().then(resp => setYear(resp));
  }, []);

  const fetchData = async () => {
    const response = await axios.get(`${API_URL}/salesgoals/year`);
    console.log("response", response.data);
    return response.data;
  };


  const [roleLevels, setRoleLevels] = useState({  
    Level1: process.env.REACT_APP_ROLE_LEVEL_1,
    Level2 : process.env.REACT_APP_ROLE_LEVEL_2,
    Level3 : process.env.REACT_APP_ROLE_LEVEL_3 });

    const [goalStatus, setGoalStatus] = useState({
      Level1: process.env.REACT_APP_GOAL_STATUS_1,
      Level2: process.env.REACT_APP_GOAL_STATUS_2,
      Level3: process.env.REACT_APP_GOAL_STATUS_3,
      Level4: process.env.REACT_APP_GOAL_STATUS_4,
    });

    // Currency state
    const [currency, setCurrency] = useState('USD'); // 'USD' | 'CAD'
    const [cadRate, setCadRate] = useState(1); // multiplier to convert USD -> CAD

    function displayCurrency(amt, locale = 'en-US') {
      if (amt !== null && amt !== undefined) {
          const multiplier = currency === 'CAD' && cadRate ? cadRate : 1;
          const converted = Math.round((amt || 0) * multiplier);
          return new Intl.NumberFormat(locale, {
              maximumFractionDigits: 0,
              useGrouping: true
          }).format(converted);
      } else {
          return "";
      }
    }
    
    function displayPct(amt) {
      if (amt === null || amt === undefined) {
        return "";
      }
      const num = Number(amt);
      if (!Number.isFinite(num) || Number.isNaN(num)) {
        return "0%";
      }
      if (num === 0) {
        return "0%";
      }
      return Math.round(num).toString() + "%";
    }
    
    
  return (
    <GlobalContext.Provider value={{ year,API_URL, roleLevels, setRoleLevels, goalStatus, setGoalStatus, currency, setCurrency, cadRate, setCadRate, displayCurrency, displayPct }}>
      {children}
    </GlobalContext.Provider>
  );
};

export default GlobalContext;